import React, { FunctionComponent } from 'react';

import styles from './InfluencerInformationRow.module.scss';
import { _t } from 'app/utils/i18n';
import { Grid, GridSize } from '@material-ui/core';
import { dateTimeFormatter } from 'app/utils/dateTimeFormatter';
import ToolTipComp from '../ToolTipComp';
import { Link } from 'react-router-dom';
import { path } from 'app/utils/path';
import { checkHoveringTranslated, checkTranslated } from 'app/utils/helpers';
import CardTitle from '../CardTitle';
import { nFormatter } from 'app/utils/numbersFormater';
import ServerError from '../ErrorBoundary/ServerError';
import {
  useHandleNavigateInfluencerOrEntity,
  useOpenModalToAddUserAsInfluencer,
} from 'app/utils/check-influencer-user';

interface Props {
  data: any;
  compId: string;
  title?: string;
  isError?: any;
  grid?: {
    xs?: GridSize;
    lg?: GridSize;
    md?: GridSize;
    sm?: GridSize;
    xl?: GridSize;
  };
  storeInfluencer?: any;
  openInSource?: string;
  hideJoinedin?: boolean;
  isChannel?: boolean;
  customKey?: string;
}
type influencerColumns = { title: string; key: string }[];

const InfluencerInformationRow: FunctionComponent<Props> = ({
  compId,
  data,
  title,
  isError,
  grid,
  storeInfluencer,
  openInSource,
  hideJoinedin,
  customKey,
  isChannel = false,
}) => {
  const [openModalToAddUserAsInfluencer] =
    useOpenModalToAddUserAsInfluencer(storeInfluencer);
  const [handleNavigateInfluencerOrEntity] =
    useHandleNavigateInfluencerOrEntity();
  const influencerColumns: influencerColumns = [
    {
      title: _t('tweets:inf_ent_name'),
      key: 'name',
    },
    {
      title: _t('videos:joined'),
      key: 'joined_at',
    },
    {
      title: _t('tweets:followers'),
      key: customKey || 'followers_count',
    },
    {
      title: _t('tweets:location'),
      key: 'location',
    },
  ];
  const influencerId = data?.influencer?.influencer_id
    ? data?.influencer?.influencer_id
    : data?.influencer?.id;
  return (
    <ServerError requiredApiCalls={[isError]}>
      <Grid item {...grid}>
        {title && (
          <Grid item sm={12} style={{ marginTop: '14px' }}>
            <CardTitle title={title} hideIcon showBorderBottom maxFontSize />
          </Grid>
        )}
        <Grid id={compId} item sm={12} className={styles.InfluencerDetails}>
          {influencerColumns?.map(({ title, key }) => (
            <div
              className={styles.InfluencerDetails__Item}
              style={
                hideJoinedin && key === 'joined_at' ? { display: 'none' } : {}
              }
              key={key}
            >
              <h5>{title}</h5>
              <span>
                {key == 'joined_at' && !hideJoinedin ? (
                  dateTimeFormatter.date(data?.influencer?.[key])
                ) : key === 'name' ? (
                  <ToolTipComp
                    title={checkHoveringTranslated(
                      data?.influencer?.name?.original,
                      data?.influencer?.name?.arabic,
                    )}
                  >
                    {influencerId > 0 ? (
                      <div
                        dir=""
                        onClick={() =>
                          handleNavigateInfluencerOrEntity(data?.influencer)
                        }
                        className="cursor-pointer"
                      >
                        {checkTranslated(
                          data?.influencer?.name?.original,
                          data?.influencer?.name?.arabic,
                        ) || data?.username}
                      </div>
                    ) : (
                      <span
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          if (
                            data?.influencer?.influencer_id === 0 ||
                            data?.influencer?.id === 0
                          ) {
                            openModalToAddUserAsInfluencer(
                              isChannel
                                ? data?.channel?.remote_id
                                : data?.username,
                              data?.influencer?.url,
                              openInSource,
                              isChannel,
                            );
                          }
                        }}
                      >
                        {checkTranslated(
                          data?.influencer?.name?.original,
                          data?.influencer?.name?.arabic,
                        ) || data?.username}
                      </span>
                    )}
                  </ToolTipComp>
                ) : key === 'location' ? (
                  data?.influencer?.location?.length ? (
                    data?.influencer?.[key]
                  ) : (
                    <span>-</span>
                  )
                ) : (
                  nFormatter(data?.influencer?.[key])
                )}
              </span>
            </div>
          ))}
        </Grid>
      </Grid>
    </ServerError>
  );
};

export default InfluencerInformationRow;
